import type { BrandIdentifiers, BrandSource, BrandSourceContext } from './types';

export type ResolvedBrandIdentifiers = BrandIdentifiers & { source: BrandSource['name'] | 'none' };

// gloss
export const resolveBrand = (sources: BrandSource[], context: BrandSourceContext): ResolvedBrandIdentifiers => {
  for (const source of sources) {
    const identifiers = source.resolve(context);
    if (identifiers) return { ...identifiers, source: source.name };
  }

  return { uuid: undefined, brandID: undefined, code: undefined, source: 'none' };
};

// gloss
export const resolveBrandCandidates = (
  sources: BrandSource[],
  context: BrandSourceContext,
): ResolvedBrandIdentifiers[] =>
  sources.flatMap((source) => {
    const identifiers = source.resolve(context);

    return identifiers ? [{ ...identifiers, source: source.name }] : [];
  });
